import { render } from "./FooterNr5.vue?vue&type=template&id=6a9c134b"
import script from "./FooterNr5.vue?vue&type=script&lang=js"
export * from "./FooterNr5.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__